<style lang="scss" scoped>
  .qr-code-display {
    display: flex;
    align-items: center;
    justify-content: center;

    .qr-code-canvas {
      max-width: 200px;
      max-height: 200px;
      border-radius: 16px;
    }
  }
</style>

<template>
  <div class="qr-code-display">
    <canvas ref="$qrCodeCanvas" class="qr-code-canvas"/>
  </div>
</template>

<script setup>
import { computed, watch, ref, onMounted } from 'vue'

import QRCode from 'qrcode'

const props = defineProps({
  url: {
    type: String,
    required: true,
  }
})

const gatewayUrl = computed(() => props.url)

const $qrCodeCanvas = ref(null)

const dataUrl = ref(null)

const generateQrCode = async () => {
  if ($qrCodeCanvas && gatewayUrl.value?.length) {
    QRCode.toCanvas($qrCodeCanvas.value, gatewayUrl.value, {
      scale: 10,
    })

    dataUrl.value = await QRCode.toDataURL(gatewayUrl.value, {
      scale: 10,
    })
  }
}

onMounted(() => {
  generateQrCode()
})

</script>

